module.exports = __webpack_public_path__ + "static/img/erweima.7b417c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/erweima.png
// module id = 3mmI
// module chunks = 1